import { Trans } from '@lingui/macro'

import * as React from 'react'

import { CreateNewOrderButton } from '../../contexts/ValidateOrderStatus/CreateNewOrderButton'
import { LockedScreenResponsiveLayout } from '../../segments/LockedScreen'
import { ReturnToPaymentButton } from './components/ReturnToPaymentButton'
import { usePaymentLockedOrderCtx } from './contexts/PaymentLockedOrderProvider'

type TProps = NoChildren

/**
 * Handles mostly the responsiveness on the PaymentLockedScreen.
 * Presents a UI with:
 *    - message to the customer,
 *    - button to go back to the payment gateway,
 *    - button to create a new order.
 * Logic is handled by components & context from the `PaymentLockedOrderProvider`.
 */
export const PaymentLockedScreenResponsiveContent: React.FC<TProps> = () => {
  const order = usePaymentLockedOrderCtx()

  const buttons = (
    <>
      <ReturnToPaymentButton />
      <CreateNewOrderButton />
    </>
  )

  return (
    <LockedScreenResponsiveLayout
      order={order}
      buttons={buttons}
      title={<Trans>Order is in payment process</Trans>}
      description={
        <Trans>
          The order has some online payment assigned that is still being processed. Please complete
          the payment or cancel it in the payment gateway.
        </Trans>
      }
    />
  )
}
